// extracted by mini-css-extract-plugin
export var chevron = "_lc-4";
export var chevronExpanded = "_lc-5";
export var row = "_lc-0";
export var rowBody = "_lc-6";
export var rowDescription = "_lc-7";
export var rowHeader = "_lc-1";
export var rowTitle = "_lc-2";
export var rowTitleComplete = "_lc-3";